import { render, staticRenderFns } from "./accountLinkingComponent.vue?vue&type=template&id=ed83e5c0&"
import script from "./accountLinkingComponent.vue?vue&type=script&lang=js&"
export * from "./accountLinkingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports